import Button from "../components/Button";
import PageTitle from "../components/PageTitle";
import Rating from "react-rating";
import {
  BsFillStarFill,
  BsHeart,
  BsFacebook,
  BsInstagram,
  BsTwitter,
  BsArrowRight,
} from "react-icons/bs";
import { useState } from "react";
import SectionHeader from "../components/SectionHeader";
import Collaboration from "../components/Collaboration";
import { useLocation, useNavigate } from "react-router-dom";

export default function ProductDetails() {
  return (
    <>
      <PageTitle title="Product Details" path={["Pages ", "Product Details"]} />
      <MainCard />
      <Info />
      <RelatedProduct />
      <Collaboration />
    </>
  );
}

// Product detail
function MainCard() {
  const { state } = useLocation();
  const navigate = useNavigate();

  return (
    <div className=" my-32 max-w-5xl mx-auto flex bg-white shadow-custom_two">
      {/* small images column */}
      <div>
        <div className="p-2 pb-0 max-w-[10rem]">
          <img
            alt=""
            className="max-w-full"
            src={require("../assets/product-details/sm01.png")}
          />
        </div>
        <div className="p-2 pb-0 max-w-[10rem]">
          <img
            alt=""
            className="max-w-full"
            src={require("../assets/product-details/sm02.png")}
          />
        </div>
        <div className="p-2 pb-0 max-w-[10rem]">
          <img
            alt=""
            className="max-w-full"
            src={require("../assets/product-details/sm03.png")}
          />
        </div>
      </div>
      {/* big image column */}
      <div className=" w-80 ">
        <div className=" p-2 h-full w-full ">
          <img
            alt=""
            className=" object-cover w-full h-full"
            src={
              state ? state.img : require("../assets/product-details/bg01.png")
            }
          />
        </div>
      </div>
      {/* text column */}
      <div className="flex-1 text-sm ml-2 font-fontOne pr-6">
        <h1 className=" text-black font-bold text-2xl mt-10 mb-3">
          Playwood arm chair
        </h1>
        <div className="flex mb-2">
          <Rating
            initialRating="4"
            readonly
            fullSymbol={<BsFillStarFill className="mr-1" color="#FFC416" />}
            emptySymbol={<BsFillStarFill className="mr-1" color="gray" />}
          />
          (22)
        </div>
        <div className=" font-fontOne mb-2">
          $32.00
          <span className=" text-pink line-through inline-block ml-2">
            $32.00
          </span>
        </div>
        <div className=" font-bold mb-2">Color</div>
        <p className=" text-sub_text_color font-fontTwo mb-4">
          Eu reprehenderit labore consectetur do. Aute voluptate ut ea pariatur.
          Irure dolore enim minim dolor aute exercitation ipsum. Culpa laboris
          eiusmod duis consectetur. Elit eu consequat ad pariatur cupidatat
          officia ea proident Lorem qui. Duis ex veniam officia qui est ullamco
          exercitation fugiat nisi.
        </p>
        <Button color="pink" onClick={() => navigate("../completed")}>
          Add To Cart <BsHeart className="inline-block ml-2" />
        </Button>
        <div className=" text-base font-semibold my-3 mb-3 ">Categories:</div>
        <div className=" text-base font-semibold mb-3">Tags:</div>
        <div className=" text-base font-semibold mb-3 flex">
          Share
          <BsFacebook className="mx-3" />
          <BsInstagram className="mr-3" />
          <BsTwitter className="" />
        </div>
      </div>
    </div>
  );
}

// description section
function Info() {
  const [currentTab, setCurrentTab] = useState(1);

  const tabs = [
    { id: 1, text: "Description" },
    { id: 2, text: "Additional Info" },
    { id: 3, text: "Reviews" },
    { id: 4, text: "Video" },
  ];

  return (
    <div className="bg-[#F9F8FE]">
      <div className=" max-w-5xl  mx-auto py-14">
        <ul className="flex mb-6">
          {tabs.map((value) => (
            <li key={value.id}>
              <button
                onClick={() => setCurrentTab(value.id)}
                className={`${
                  currentTab === value.id && "underline"
                } font-bold font-fontTwo mr-14 hover:underline text-xl`}
              >
                {value.text}
              </button>
            </li>
          ))}
        </ul>
        {currentTab === 1 && (
          <div>
            <h2 className="text-xl font-bold mt-10 mb-2 font-fontOne">
              Various Temper
            </h2>
            <p className=" text-sub_text_color">
              Eiusmod in sit quis veniam in anim commodo aute ipsum sint ipsum
              veniam do. Quis non ullamco enim laboris do labore in. Magna nulla
              culpa velit est. Ut aute ut occaecat aute cillum enim officia
              mollit ea non elit nostrud id esse. Adipisicing deserunt
              exercitation dolore esse proident fugiat et consectetur ex sunt
              sunt ex. In dolor esse ad veniam. Sint incididunt reprehenderit
              esse aliquip incididunt labore ut exercitation do deserunt mollit.
              Minim dolor dolor magna exercitation ad. Ipsum elit mollit
              excepteur quis. Fugiat dolor pariatur aute laboris cupidatat magna
              qui laboris fugiat qui officia excepteur nulla. Fugiat adipisicing
              commodo minim enim nulla incididunt magna consequat aute eu qui
              pariatur occaecat. Minim magna sunt dolore est. Esse proident sit
              aute reprehenderit labore ut velit nostrud adipisicing occaecat.
            </p>
            <h2 className="text-xl font-bold mt-10 mb-2 font-fontOne">
              More Details
            </h2>
            <ul>
              <li className="flex items-start">
                <BsArrowRight className="mr-2 w-5 mt-1" />
                <p className=" text-sub_text_color">
                  Sit sit culpa fugiat cupidatat sit commodo id nisi. Do
                  cupidatat sunt cupidatat aliquip sunt eiusmod mollit.
                </p>
              </li>
              <li className="flex items-start">
                <BsArrowRight className="mr-2 w-5 mt-1" />
                <p className=" text-sub_text_color">
                  Ad veniam anim est adipisicing laboris exercitation.
                  Incididunt consectetur commodo enim exercitation.
                </p>
              </li>
              <li className="flex items-start">
                <BsArrowRight className="mr-2 w-5 mt-1" />
                <p className=" text-sub_text_color">
                  Cillum sit incididunt veniam dolor in mollit. Occaecat ut
                  ullamco dolore nisi.
                </p>
              </li>
              <li className="flex items-start">
                <BsArrowRight className="mr-2 w-5 mt-1" />
                <p className=" text-sub_text_color">
                  Cillum aute est laboris consequat proident mollit. Quis veniam
                  pariatur excepteur aliqua nisi deserunt proident tempor
                  deserunt. Duis ipsum aliquip officia sint magna.
                </p>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

// row of cards
function RelatedProduct() {
  return (
    <div className="mx-auto max-w-5xl">
      <SectionHeader left>Related Product</SectionHeader>
      <div className="flex justify-between">
        <Card
          img={require("../assets/product-details/related-product01.png")}
        />
        <Card
          img={require("../assets/product-details/related-product02.png")}
        />
        <Card
          img={require("../assets/product-details/related-product03.png")}
        />
        <Card
          img={require("../assets/product-details/related-product04.png")}
        />
      </div>
    </div>
  );
}

// card of related products
function Card({ img }) {
  return (
    <div className="text-sm max-w-[16rem] font-fontOne p-2 flex flex-col justify-center">
      {/* image container */}
      <div className=" overflow-hidden max-w-[15rem] mb-3">
        <img alt="" src={img} />
      </div>
      {/* text container */}

      <div className="flex justify-between mb-1">
        <h4 className="font-semibold">Men's Fashion Wear</h4>
        <div>
          <Rating
            initialRating="4"
            readonly
            fullSymbol={
              <BsFillStarFill className="mr-1" size={10} color="#FFC416" />
            }
            emptySymbol={
              <BsFillStarFill className="mr-1" size={10} color="gray" />
            }
          />
        </div>
        {/* price */}
      </div>
      <div>$64.00</div>
    </div>
  );
}
